import { Router } from '@angular/router';
import { CertificadosService } from 'src/app/services/certificados.service';
import { FormBuilder } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
var Resumen_certComponent = /** @class */ (function () {
    function Resumen_certComponent(fb, dialog, _router, _certService) {
        /*  if(this.corvi.length > 0){
              for (let i = 0; i < this.corvi.length; i++) {
                  if(this.corvi[i].tipo_permiso == "corvi"){
                      this.corvi.push(this.corvi[i]);
                  }
                  else if(this.corvi.length == 0 && this.corvi.length == (i+1)){
                      this.corvi = [{fecha:'',corvi:''}];
  
                  }
              }
          }
  
          if(this.tipos_cert.length > 0){
              for (let i = 0; i < this.tipos_cert.length; i++) {
                  if(this.tipos_cert[i] == "tipos_certificados"){
                      this.tipos_cert.push(this.tipos_cert[i]);
                  }
                  else if(this.tipos_cert.length == 0 && this.tipos_cert.length == (i+1)){
                      this.tipos_cert = [{fecha:'',corvi:''}];
  
                  }
              }
          }*/
        this.fb = fb;
        this.dialog = dialog;
        this._router = _router;
        this._certService = _certService;
        this.rows = [];
        this.matcher = new FormService();
        this.ngAfterContentInit();
        // this.corvi = {fecha: null,corvi:''};
    }
    Resumen_certComponent.prototype.ngAfterContentInit = function () {
        if (this.corvi.length > 0) {
            console.log(this.corvi);
            for (var i = 0; i < this.corvi.length; i++) {
                if (this.corvi[i].tipo_permiso == "corvi") {
                    this.corvi.push(this.corvi[i]);
                }
                else if (this.corvi.length == 0 && this.corvi.length == (i + 1)) {
                    this.corvi = [{ fecha: '', corvi: '' }];
                }
            }
        }
        if (this.tipos_certificados.length > 0) {
            console.log(this.tipos_certificados);
            for (var i = 0; i < this.tipos_certificados.length; i++) {
                if (this.tipos_certificados[i] == "tipos_certificados") {
                    this.tipos_certificados.push(this.tipos_certificados[i]);
                    console.log(this.tipos_certificados);
                }
                else if (this.tipos_certificados.length == 0 && this.tipos_certificados.length == (i + 1)) {
                    this.tipos_certificados = [{ rol: '', id_direcc: '', folio: '', tipo_cert: '' }];
                }
            }
        }
        if (JSON.parse(localStorage.getItem("propiedades")).length > 0) {
            this.propiedades = JSON.parse(localStorage.getItem("propiedades"));
        }
        else {
            localStorage.setItem("propiedades", JSON.stringify([]));
            this.propiedades = [{ rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', direc_anexo: '', direc_anexo_num: '', loteo: '', manzana: '', plano: '', ubicacion: '', valido: '', recordId: '' }];
        }
    };
    Resumen_certComponent.prototype.getResumen = function () {
    };
    return Resumen_certComponent;
}());
export { Resumen_certComponent };
